import { Component } from 'react';

import Footer from '../Footer/Footer';
import Main from '../Main';
import Topbar from '../Topbar';
import css from './ContentCenteredLayout.css';
import { LayoutProps } from './MainLayout';

interface ContentCenteredLayoutProps extends LayoutProps {}

export default class ContentCenteredLayout extends Component<ContentCenteredLayoutProps, {}> {
  render() {
    const {
      appState,
      children,
      embeddedQuery: { embed },
    } = this.props;
    const showFooter = !embed && !appState.store.isShowroom();

    return (
      <div className={css.ContentCenteredLayout}>
        {!embed && <Topbar appState={appState} translation={appState.translation.layout.topBar} />}
        <Main className={css.content}>{children}</Main>
        {showFooter && (
          <Footer
            data={appState.navigationState.footer}
            homeUrl={appState.navigationState.homeUrl}
            storeContext={appState.storeResponse.storeContext}
          />
        )}
      </div>
    );
  }
}
